import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { JwtService } from '../index.service';

@Injectable({
  providedIn: 'root'
})
export class ReportService {
  readonly BASE_URL = environment.BASE_API_URL;
  constructor(
    private http:HttpClient,
    private jwtService:JwtService  
  ) { }
  reportPost(slug:string , data:string){
    return this.http.post(`${this.BASE_URL}post/${slug}/report/` , {detail:data} )
  }
}
